export default class MyVehicle {
    plate: String
    color: String
    model: String
    year: number
    
    constructor(plate, color, model, year) {
        this.plate = plate
        this.color = color
        this.model = model
        this.year = year
    }
}